var map = {
	"./Paper-AvMed.svg": [
		96957,
		6957
	],
	"./Paper-BCBSAZ.svg": [
		85245,
		5245
	],
	"./Paper-C4.svg": [
		66397,
		6397
	],
	"./Paper-C4CT.svg": [
		69936,
		9936
	],
	"./Paper-CG.svg": [
		8910,
		8910
	],
	"./Paper-X6.svg": [
		98462,
		8462
	],
	"./Paper-XC.svg": [
		10803,
		803
	]
};
function webpackAsyncContext(req) {
	if(!__webpack_require__.o(map, req)) {
		return Promise.resolve().then(() => {
			var e = new Error("Cannot find module '" + req + "'");
			e.code = 'MODULE_NOT_FOUND';
			throw e;
		});
	}

	var ids = map[req], id = ids[0];
	return __webpack_require__.e(ids[1]).then(() => {
		return __webpack_require__.t(id, 1 | 16);
	});
}
webpackAsyncContext.keys = () => (Object.keys(map));
webpackAsyncContext.id = 43667;
module.exports = webpackAsyncContext;